

/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


import './view.scss';

import {YLWPUXsendGAEvent, YLWPUXsendWPEvent} from '../wpcroux';

const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
	const { top, left, bottom, right } = el.getBoundingClientRect();
	const { innerHeight, innerWidth } = window;
	return partiallyVisible
		? ((top > 0 && top < innerHeight) ||
			(bottom > 0 && bottom < innerHeight)) &&
		((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
		: top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};

let scrollEventElements = document.querySelectorAll('div[data-scrollevent="true"]');

for( const scrollEventElement of scrollEventElements) {
	let scrollElementID = scrollEventElement.getAttribute('data-scrollelementid');
	//By default, we use Window as scroll event trigger
	let scrollElement = window;

	if ((null !== scrollElementID) && (false !== scrollElementID)) {
		scrollElement = document.getElementById(scrollElementID);
	} else {
		scrollElementID = 'window';
	}

	scrollElement.addEventListener("scroll", (event) => {

		if (true === elementIsVisibleInViewport(scrollEventElement, true)) {
			window.requestAnimationFrame(() => {

				let eventName = scrollEventElement.getAttribute('data-ywpuxtrackname');
				let eventValue = scrollEventElement.getAttribute('data-ywpuxtracknvalue');
				let blockID = scrollEventElement.getAttribute('data-trackblockid');

				console.log('Scroll event registered on "'+scrollElementID+'" with name "'+eventName+'" and value "'+eventValue +'"');

				YLWPUXsendGAEvent(eventName, eventValue);
				YLWPUXsendWPEvent(blockID, eventName, eventValue);

				scrollEventElement.remove();
			});
		}
	});
}





